export default {
  methods: {
    /** START MANDATORY DEVICES METHODS */

    /** GET MANDATORY DEVICE CATEGORIES OCCURENCES  */
    get_mandatory_occurences () {
      const cat_occurences = {};
      [...this.chosenOffer.mandatory_devices].forEach(mandatory_device => {
        mandatory_device.allowed_categories.forEach(allowed_category => {
          cat_occurences[allowed_category.name] === undefined
            ? cat_occurences[allowed_category.name] = 1
            : cat_occurences[allowed_category.name]++
        })
      })
      return cat_occurences
    },

    /** LIST OF CATEGORIES FROM CHOSEN CATEGORIES PRESENT IN MANDATORY DEVICES */
    list_cat_related_to_mandatory_devices (cat_occurences) {
      return this.devices.map(device => device.chosenCategory?.name)
        /* Filter them to get only the not null and if they are on categories of mandatory devices */
        .filter(cat => cat !== null && cat_occurences[cat] !== undefined)
    },

    /** GET MANDATORY DEVICES LEFT NUMBER */
    /* We don't need to be as accurate as when we get the categories of mand devices, because here we just need a number so we don't care that
     * a same category could be in different mand devices (and could give categories of both of these mand devices) */
    get_mandatory_categories_number_left (list_cat) {
      /* Sort mand devices by length ascending allow us to put the mand device priorities */
      const mandatory_devices = [...this.chosenOffer.mandatory_devices]
        .sort((mand_dev_a, mand_dev_b) => mand_dev_a.allowed_categories.length - mand_dev_b.allowed_categories.length)
      list_cat.forEach(cat => {
        for (let i = 0; i < mandatory_devices.length; i++) {
          const current_cat_is_in_current_cat_allowed = mandatory_devices[i].allowed_categories
            .some(cat_mandatory => cat_mandatory.name === cat)

          /* If category is present in allowed category => remove the allowed category */
          if (current_cat_is_in_current_cat_allowed) {
            return mandatory_devices.splice(i, 1)
          }
        }
      })

      return mandatory_devices.length
    },

    /** GET MANDATORY DEVICES OBLIGATORY */
    /* Meaning get the mandatory devices where none of their categories are chosen in category of devices */
    get_obligatory_devices_left (mandatory_devices, list_cat) {
      /* Get the list of mandatory devices of categories and for each, check if the category has already been chosen */
      const check_cat_present = mandatory_devices
        .map(mandatory_device => mandatory_device.allowed_categories
          .map(mand_cat => list_cat.some(cat => cat === mand_cat.name)))

      /* Filter the mandatory devices where none of the categories has been chosen */
      return mandatory_devices.filter((mandatory_device, index) => check_cat_present[index].every(is_cat_present => !is_cat_present))
    },

    /** GET MANDATORY DEVICES LEFT IF THERE IS NO OBLIGATORY */
    /* Filter every mandatory devices when there is more occurences of categories from device than categories from mand devices */
    get_mandatory_devices_left (mandatory_devices, my_cat_occurences, cat_occurences) {
      for (const [key, value] of Object.entries(my_cat_occurences)) {
        /* if they are more categories occurences in mandatory device than in the chosen categories occurences
         * Filter the mandatory devices without the category */
        if (cat_occurences[key] <= value) {
          mandatory_devices = mandatory_devices.filter(device_mandatory => {
            const my_cats_not_in_device_mand = !(device_mandatory.allowed_categories.some(cat => cat.name === key))

            /* If mandatory device has the current cat, for each cat of this mandatory device remove 1 occurence associated */
            if (!my_cats_not_in_device_mand) {
              device_mandatory.allowed_categories.forEach(cat => cat_occurences[cat.name]--)
            }
            return my_cats_not_in_device_mand
          })
          /* Remove property of the current cat from the occurences of chosen categories */
          delete my_cat_occurences[key]

          /* Make verification until there is no more mandatory devices filtered */
          return this.get_mandatory_devices_left(mandatory_devices, my_cat_occurences, cat_occurences)
        }
      }
      return mandatory_devices
    }, /** END MANDATORY DEVICES METHODS */

    /** START PACKS METHODS */
    packsMappedWithOnlyChosenCategories (devicesPacks, categoriesChosenPresentInPacks) {
      const packsInProgressWithCategories = []

      /* Create a list of multiple categories who are present in a pack */
      devicesPacks.forEach(pack => {
        const packInProgressCategories = []
        pack.forEach(packCategories => packCategories.forEach(cat => {
          if (categoriesChosenPresentInPacks.some(category => category === cat.category.name)) {
            packInProgressCategories.push(cat.category.name)
          }
        }))
        packsInProgressWithCategories.push(packInProgressCategories.length !== 0
          ? packInProgressCategories
          : [])
      })
      return packsInProgressWithCategories
    },

    indexPackWithMostCat (devicesPacks, categoriesChosenPresentInPacks) {
      return this.packsMappedWithOnlyChosenCategories(devicesPacks, categoriesChosenPresentInPacks)
        .findIndex(categories => categories.join() === this.categoriesChosenFromPackWithMostCat(devicesPacks, categoriesChosenPresentInPacks)
          .join())
    },

    categoriesChosenFromPackWithMostCat (devicesPacks, categoriesChosenPresentInPacks) {
      return this.packsMappedWithOnlyChosenCategories(devicesPacks, categoriesChosenPresentInPacks)
        .reduce((acc, cur) => cur.length > acc.length ? cur : acc)
    },

    categoriesLeftFromPackWithMostCat (devicesPacks, categoriesChosenPresentInPacks) {
      return devicesPacks[this.indexPackWithMostCat(devicesPacks, categoriesChosenPresentInPacks)]
        .filter(catPack => catPack.every(cat => categoriesChosenPresentInPacks.indexOf(cat.category.name) === -1))
        .flat()
    },

    packWithMostCatHasAvailableCategory (devicesPacks, categoriesChosenPresentInPacks) {
      return devicesPacks[this.indexPackWithMostCat(devicesPacks, categoriesChosenPresentInPacks)].some(catPack => catPack.every(cat => categoriesChosenPresentInPacks.indexOf(cat.category.name) === -1))
    },

    categoriesFromPacksInProgress (categoriesChosenPresentInPacks = [...this.categoriesChosenPresentInPacks]) {
      const categoriesFromPacksInProgress = []
      const devicesPacksSortedLengthDesc = [...this.devicesPacksSortedLengthDesc]

      while (devicesPacksSortedLengthDesc.length !== 0 && categoriesChosenPresentInPacks.length !== 0) {
        categoriesFromPacksInProgress.push(...this.categoriesLeftFromPackWithMostCat(devicesPacksSortedLengthDesc, categoriesChosenPresentInPacks))

        /** We make a copy, else the pack would be splice */
        const devicesPacksCopy = [...devicesPacksSortedLengthDesc]
        /** Remove the pack from the list */
        devicesPacksSortedLengthDesc.splice(this.indexPackWithMostCat(devicesPacksSortedLengthDesc, categoriesChosenPresentInPacks), 1)
        /** Remove categories of the pack with most cat from the list categories */
        this.categoriesChosenFromPackWithMostCat(devicesPacksCopy, categoriesChosenPresentInPacks)
          .forEach(cat => categoriesChosenPresentInPacks.splice(categoriesChosenPresentInPacks.findIndex(listCatElement => listCatElement === cat), 1))
      }

      return categoriesFromPacksInProgress
        .map(cat => cat.category)
        /* Remove duplicates */
        .filter((cat, index, arr) => arr.findIndex(category => category.id === cat.id) === index)
    },
    /** END PACKS METHODS */

    categoriesWithoutDuplicates: categories => categories.filter((cat, index, arr) => {
      return arr.findIndex(elem => elem.name === cat.name) === index
    }),

    categoriesSorted: categories => categories.sort((categoryA, categoryB) => categoryA.name.localeCompare(categoryB.name)),

    savePack (categories, packIdentifier) {
      categories = categories
        .filter(category => category !== null)

      if (categories.length === 0) return

      let index = this.currentDeviceIndex
      this.devices.splice(index, 1)
      categories
        .forEach(category => {
          const newDevice = { ...this.deviceTemplate }
          newDevice.chosenCategory = category
          newDevice.pack_identifier = packIdentifier
          this.devices.splice(index, 0, newDevice)
          this.setDefaultBrandOnDeviceIfNeeded(index++)

          this.visibleModal = null
        })
    },

    openModalDeletePack (packIdentifier) {
      this.currentDeletePack = packIdentifier
      this.visibleModal = this.modalNames.deletePack
    },

    packIdentifierIndex (packIdentifier) {
      return this.packIdentifiers.indexOf(packIdentifier) + 1
    },

    addDeviceIfNone () {
      if (this.devices.length === 0) {
        this.newDevice()
      }
    },

    deletePack () {
      this.devices = this.devices.filter(device => {
        if (this.currentDeviceIndex !== 0) {
          this.currentDeviceIndex--
        }
        return device.pack_identifier !== this.currentDeletePack
      })
      this.addDeviceIfNone()
      this.visibleModal = null
    }
  }
}
